import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", delay = 0, as = "h2", inView = true, testId }) => {
  const Tag = motion[as];
  const trigger = inView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } }
    : { initial: "hidden", animate: "show" };
  return (
    <Tag className={className} data-testid={testId} {...trigger} transition={{ staggerChildren: 0.12, delayChildren: delay }}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className="block will-change-transform"
            variants={{ hidden: { y: "105%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE } } }}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay, ease: EASE }} {...rest}>
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`eyebrow flex items-center gap-3 ${light ? "text-sky-300" : "text-sky-700"}`}>
    <span className={`h-px w-8 ${light ? "bg-sky-300" : "bg-sky-700"}`} />{children}
  </p>
);
